export interface RoutineConfig {
  title: string;
  routineButtonText?: string;
  issuePrefix?: string;
  reportOnException?: boolean;
  inventory?: boolean;
  uom?: string;
}

export interface SingleStateConfig extends RoutineConfig {
  instructions: string;
}
